const Credenciamento = () => {
  return window.location.replace(
    'https://sigevent.pro/merkator/visitantes/formularios.php?id_edicao=403'
  );
};

export default Credenciamento;
